<header [style.backgroundColor]="brandColor" class="d-flex">
  <div class="header justify-content-between d-flex align-items-center container-fluid">

    <a [routerLink]="[currentLang, RouterUrls.Brands, brandSlug]" class="logo">
      <img [src]="brandLogoUrl" alt="brand logo" loading="lazy">
    </a>
    <div class="right-part d-lg-flex">
      <div (click)="openCloseLanguageList()" class="language ns-mr-12 ns-ml-12">
        <div class="language-icon">{{'HEADER.languages' | translate}}</div>
        <div class="language-dropdown-arrow"></div>
        <div [class.no-pointer-events]="!isLanguageListOpened" class="language-list-wrapper-wrapper">
          <div [ngClass]="{'has-border': isLanguageListOpened}" class="language-list-wrapper">
            <ul *ngIf="isLanguageListOpened" [@inOutAnimation] class="language-list">
              <li><a (click)="changeLanguage('es')" [ngClass]="{'active-lang': currentLang === '/es'}"
                     class="language-element"
                     routerLinkActive="active-lang">{{'LANGUAGES.spanish' | translate}}</a></li>
              <li><a (click)="changeLanguage('fr')" [ngClass]="{'active-lang': currentLang === '/fr'}"
                     class="language-element"
                     routerLinkActive="active-lang">{{'LANGUAGES.french' | translate}}</a></li>
              <li><a (click)="changeLanguage('en')" [ngClass]="{'active-lang': currentLang === '/en'}"
                     class="language-element"
                     routerLinkActive="active-lang">{{'LANGUAGES.english' | translate}}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
